import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { ClickAbsorber } from './ClickAbsorber';

export interface IconButtonLinkProps extends Omit<IconButtonProps, 'component' | 'href'> {
  readonly to: string;
  readonly openInNewTab?: boolean;
  readonly target?: string;
}

/**
 * MUI IconButton component that acts as a link using React Router
 * This component prevents the double navigation issue that can occur with nested click handlers
 * and properly forwards refs and props as required by MUI Tooltip
 */
export const IconButtonLink = React.forwardRef<HTMLButtonElement, IconButtonLinkProps>(
  ({ to, openInNewTab = false, target, children, ...rest }, ref) => {
    const linkTarget = openInNewTab ? '_blank' : target;

    return (
      <ClickAbsorber preventDefault={false}>
        <IconButton ref={ref} component={Link as any} to={to} target={linkTarget} {...rest}>
          {children}
        </IconButton>
      </ClickAbsorber>
    );
  },
);
